/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@dm/core';

import { ExportModule } from '../header-settings/export/export.module';
import { SmartAssistantAlarmsModule } from './alarms/assistant-alarms.module';
import { SmartAssistantFileShareModule } from './file-share/file-share.module';
import { SmartAssistantObjectProtectionModule } from './object-protection/object-protection.module';
import { StorageResourcesGuidanceModule } from './provisioning-guidance/storage-resources-guidance.module';
import { SmartAssistantReportModule } from './report/assistant-report.module';
import { SmartAssistantComponent } from './smart-assistant.component';
import { SmartAssistantService } from './smart-assistant.service';
import { SmartAssistantStrService } from './smart-assistant-str.service';
import { SmartAssistantSwitchModule } from './smart-assistant-switch/smart-assistant-switch.module';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        FormsModule,
        SmartAssistantSwitchModule,
        StorageResourcesGuidanceModule,
        ExportModule,
        SmartAssistantFileShareModule,
        SmartAssistantObjectProtectionModule,
        SmartAssistantAlarmsModule,
        SmartAssistantReportModule,
    ],
    declarations: [SmartAssistantComponent],
    exports: [SmartAssistantComponent],
    providers: [SmartAssistantStrService, SmartAssistantService],
})
export class SmartAssistantModule { }
